import firebase from 'Firebase'
import 'Firebase/firestore'
import config from './config'
import moment from 'moment'

firebase.initializeApp(config)


const state = {
  db: null,
  storage: null
}

const mutations = {
  SET_DATABASE: function (state) {
    if (state.db === null) {
      state.db = firebase.firestore()
    }

    if (state.storage === null) {
      state.storage = firebase.storage();
    }
  },
  RESET_DATABASE: function (state) {
    state.db = null;
    state.storage = null;
  },
}

const actions = {

  initializeDatabase({ commit, dispatch, rootState }, user) {

    commit("SET_MESSAGE", "Downloading data...")
    
    dispatch('initializeDevices', user.devices)
    .then((devices)=>{
      return dispatch('initializeCategories', devices)
    })
    .then(()=>{
      return dispatch('initializeBrands')
    })
    .then(()=>{
      return dispatch('initializeVideos')
    })
    .then(()=>{
      return dispatch('downloadTodaysStats')    
    })
    .then(()=>{
      commit("CLEAR_MESSAGE") 
    })
  }
}

export default {
  mutations,
  state,
  actions,
} 



// WEBPACK FOOTER //
// ./src/store/modules/Database.js